import { Controller } from "@hotwired/stimulus"

// Filters the ticket list by submitting the filter form with Turbo
// data-controller="support--ticket-filter"
export default class extends Controller {
  static targets = ["form", "statusTab"]
  static values = { url: String }

  connect() {
    // Auto-submit on any select change
    this._changeHandler = () => this.submit()
    this._boundElements = this.element.querySelectorAll(
      "select, input[type=checkbox]",
    )
    this._boundElements.forEach((el) => {
      el.addEventListener("change", this._changeHandler)
    })
  }

  disconnect() {
    if (this._boundElements && this._changeHandler) {
      this._boundElements.forEach((el) => {
        el.removeEventListener("change", this._changeHandler)
      })
    }
  }

  submit() {
    this.formTarget.requestSubmit()
  }

  setStatus(event) {
    event.preventDefault()
    const status = event.currentTarget.dataset.status
    const input = this.formTarget.querySelector("[name='status']")
    if (input) input.value = status

    // Update active tab styling
    this.statusTabTargets.forEach((tab) => {
      tab.classList.toggle("bg-primary", tab.dataset.status === status)
      tab.classList.toggle(
        "text-primary-foreground",
        tab.dataset.status === status,
      )
    })

    this.submit()
  }
}
